import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useMerchantNotifications = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    ["merchantNotifications"],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/order/orders/merchant/me/notifications`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data.notifications;
    },
    { enabled: !!token }
  );
};

export default useMerchantNotifications;
